import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Modal from '@/popup/components/shared/Modal/Modal'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import Button from '@/popup/components/shared/Button.vue'

type Props = {
  networkName?: string
  onConfirm(): void
  onCancel(): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkDelete',
  props: {
    networkName: {},
    onConfirm: { type: Function },
    onCancel: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "data-testid": "modal-network-delete" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background),
      _createVNode(_unref(Modal).Content, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modal.network_delete.heading')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_unref(Modal).Text, null, {
            default: _withCtx(() => [
              _createVNode(Sanitize, {
                html: _ctx.$t('modal.network_delete.text', { networkName: _ctx.networkName })
              }, null, 8 /* PROPS */, ["html"])
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", null, [
            _createVNode(Button, {
              variant: "primary",
              "is-full-width": true,
              "data-testid": "confirm",
              onClick: _ctx.onConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modal.network_delete.delete')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _createVNode(Button, {
              class: "pb-0",
              variant: "text",
              "is-full-width": true,
              "data-testid": "cancel",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modal.network_delete.cancel')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})